<template>
  <div class="mt-5">
    <v-card tile outlined flat>
      <v-data-table
        :loading="loading"
        class="custom__table"
        :items="items"
        :headers="headers"
      >
        <template v-slot:item.status="{ item }">
          <status :status="item.status"></status>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import reportService from "../../assets/services/report.service";
import Status from "./Status.vue";
export default {
  components: { Status },
  data() {
    return {
      items: [],
      loading: true,
      headers: [
        { text: "Autono", value: "autono", divider: true },
        { text: "Username", value: "username", divider: true },
        { text: "Mobile Number", value: "mobile_no", divider: true },
        { text: "Item ID", value: "item_id", divider: true },
        { text: "Item Name", value: "item_name", divider: true },
        { text: "Status", value: "status", divider: true },
        { text: "Price", value: "price", divider: true },
        { text: "Qty", value: "qty", divider: true },
        { text: "Total Price", value: "total_price", divider: true },
        { text: "Rechargge ID", value: "recharge_id", divider: true },
        { text: "Remark", value: "remark", divider: true },
        { text: "Admin Remark", value: "admin_remark", divider: true },
        { text: "Address", value: "address", divider: true },
        { text: "Customer name", value: "customer_name", divider: true },
        { text: "Phone", value: "customer_mobileno", divider: true },
        { text: "Pincode", value: "pincode", divider: true },
        { text: "Create Date", value: "created_date", divider: false },
      ],
    };
  },
  methods: {
    format(date) {
      if (!date) return "";
      return moment(date, "MM/DD/YYYY hh:mm:ss a").format("DD-MM-YYYY hh:mm a");
    },
    async init() {
      const vm = this;
      try {
        vm.loading = true;
        let { data } = await reportService.orders();
        if (data.status == "true") {
          vm.items = data.data.map((item) => {
            let { created_date } = item;
            item.created_date = vm.format(created_date);
            return item;
          });
        } else {
          vm.$alert.show(data.message);
        }
        console.log(data);
        vm.loading = false;
      } catch (error) {
        vm.loading = false;
        vm.$alert.show(error.message);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>